import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/apiClient";
import { Wordmark } from "@/components/Wordmark";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user.role) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(form.username, form.password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-ink-900 noise flex items-center justify-center p-5">
      <div className="absolute inset-0 mesh-top opacity-60" />
      <div className="relative w-full max-w-md rounded-3xl glass p-9 glow-blue">
        <div className="flex items-center gap-3 mb-8">
          <Lock size={18} className="text-cyan" />
          <Wordmark size="text-lg" />
        </div>
        <h1 className="font-display text-3xl font-bold text-white">Admin access</h1>
        <p className="text-mist text-sm mt-2 mb-7">Sign in to the I•AMovement dashboard.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="admin-username" required placeholder="Username" value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            className="w-full rounded-xl bg-ink-800 border border-white/12 px-5 py-3.5 text-ice placeholder:text-mist focus:border-cyan/60 outline-none" />
          <input data-testid="admin-password" required type="password" placeholder="Password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full rounded-xl bg-ink-800 border border-white/12 px-5 py-3.5 text-ice placeholder:text-mist focus:border-cyan/60 outline-none" />
          {error && <p className="text-red-300 text-sm" data-testid="admin-login-error">{error}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="book-cta w-full justify-center">
            {loading ? <Loader2 className="animate-spin" size={16} /> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
